<template>
    <div class="relative barsParent" :style="{ '--border-size-prop': smallBorders ? '1.3px' : '2.5px' }">
        <div class="outerBorder">
            <div class="middleBorder">
                <div class="innerBorder" :style="{ backgroundColor: colorShades.inner }">
                    <div class="inner" :style="{ backgroundColor: color }">
                        <div
                            class="topBar horizontal top-0"
                            :style="{ backgroundColor: colorShades.top }"
                            v-if="!hideBars"
                        ></div>
                        <div
                            class="bottomBar horizontal bottom-0"
                            :style="{ backgroundColor: colorShades.bottom }"
                            v-if="!hideBars"
                        ></div>
                        <div
                            class="leftBar vertical left-0"
                            :style="{ backgroundColor: colorShades.left }"
                            v-if="!hideBars"
                        ></div>
                        <div
                            class="rightBar vertical right-0"
                            :style="{ backgroundColor: colorShades.right }"
                            v-if="!hideBars"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="absolute h-full w-full">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CamelraceCard',
    props: {
        color: {
            type: String,
            default: '#E50328',
        },
        hideBars: {
            type: Boolean,
            default: false,
        },
        smallBorders: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        colorShades() {
            return this.generateColorShades(this.color)
        },
    },
    methods: {
        generateColorShades(baseColor) {
            // Convert hex to RGB
            const hex = baseColor.replace('#', '')
            const r = parseInt(hex.substr(0, 2), 16)
            const g = parseInt(hex.substr(2, 2), 16)
            const b = parseInt(hex.substr(4, 2), 16)

            // Generate shades
            const lighten = (r, g, b, factor) => {
                const newR = Math.min(255, Math.floor(r + (255 - r) * factor))
                const newG = Math.min(255, Math.floor(g + (255 - g) * factor))
                const newB = Math.min(255, Math.floor(b + (255 - b) * factor))
                return `rgb(${newR}, ${newG}, ${newB})`
            }

            const darken = (r, g, b, factor) => {
                const newR = Math.max(0, Math.floor(r * (1 - factor)))
                const newG = Math.max(0, Math.floor(g * (1 - factor)))
                const newB = Math.max(0, Math.floor(b * (1 - factor)))
                return `rgb(${newR}, ${newG}, ${newB})`
            }

            return {
                left: lighten(r, g, b, 0.2), // Brightest
                top: lighten(r, g, b, 0.1), // A little brighter
                right: darken(r, g, b, 0.1), // A little darker
                bottom: darken(r, g, b, 0.2), // Darkest
                inner: darken(r, g, b, 0.4), // Slightly darker than base
            }
        },
    },
}
</script>

<style lang="scss">
.barsParent {
    --border-size: var(--border-size-prop);
    --border-size-half: calc(var(--border-size) / 2);

    @media (min-width: 1024px) {
        --border-size: calc(var(--border-size-prop) * 1.8);
        --border-size-half: calc(var(--border-size) / 2);
    }
}

.horizontal {
    height: var(--border-size);
    width: calc(100% - var(--border-size));
    margin: 0 var(--border-size);
    background-color: #ffffff;
    clip-path: polygon(
        calc(var(--border-size-half)*-1) 0,
        calc(100% + var(--border-size-half)) 0,
        calc(100% - var(--border-size-half)) var(--border-size),
        var(--border-size-half) var(--border-size)
    );
    border-radius: var(--border-size) var(--border-size) 0 0;

    &.bottomBar {
        transform: scaleY(-1);
    }
}
.vertical {
    width: var(--border-size);
    height: calc(100% - var(--border-size));
    background-color: #000000;
    margin: var(--border-size-half) 0;
    clip-path: polygon(
        0 calc(var(--border-size-half)*-1),
        var(--border-size) var(--border-size-half),
        var(--border-size) calc(100% - var(--border-size-half)),
        0 calc(100% + var(--border-size-half))
    );
    border-radius: 0.5rem 0 0 0.5rem;

    &.rightBar {
        transform: scaleX(-1);
    }
}

.horizontal,
.vertical {
    position: absolute;
    overflow: hidden;
    z-index: 1;
}

.outerBorder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f7d073;
    z-index: 0;
    border-radius: calc(0.25rem + var(--border-size)*3);
    padding: var(--border-size);

    .middleBorder {
        width: 100%;
        height: 100%;
        background-color: #e88439;
        border-radius: calc(0.25rem + var(--border-size)*2);
        padding: var(--border-size);

        .innerBorder {
            width: 100%;
            height: 100%;
            background-color: #781615;
            border-radius: calc(0.25rem + var(--border-size));
            padding: var(--border-size);

            .inner {
                width: 100%;
                height: 100%;
                border-radius: 0.25rem;
                position: relative;
            }
        }
    }
}


</style>
